import React from 'react';
import {PricingTable, PricingSlot, PricingDetail} from 'react-pricing-table';
import QA from './QA'
import "./style.css"

export default function WhoAreWe() {
  return (
    <div>
      <div class="about-section" id="whoarewe">
        <h1>?למה אנחנו</h1>
        <p>טקסט שמסביר למה אנחנו הכי טובים בזה</p>
        <p>אפשר עוד טקסט למה לשהתמש בפלטפורמה וכו</p>
      </div>

      <h2 className="ourteam-section">הצוות שלנו</h2>

        <div style={{textAlign: "center", display: "flex", justifyContent: "center"}} class="row">
         <div class="column">
           <div class="card">
            <img src="https://source.unsplash.com/_kFIIY0EYQ4/1600x900" alt="Aysam" style={{width:"100%"}}/>
             <div class="container">
              <h2>Aysam Farhoud</h2>
              <p class="title">Lead Programmer</p>
              <p>Full Stack Developer & Web Specialist</p>
              <p>aysam@example.com</p>
            </div>
          </div>
        </div>

        <div class="column">
           <div class="card">
            <img src="https://source.unsplash.com/_kFIIY0EYQ4/1600x900" alt="Aysam" style={{width:"100%"}}/>
             <div class="container">
              <h2>Aysam Farhoud</h2>
              <p class="title">Lead Programmer</p>
              <p>Full Stack Developer & Web Specialist</p>
              <p>aysam@example.com</p>
            </div>
          </div>
        </div>
      </div>

      <div style={{textAlign: "center", display: "flex", justifyContent: "center"}} class="row">
        <div class="column">
           <div class="card">
            <img src="https://source.unsplash.com/_kFIIY0EYQ4/1600x900" alt="Aysam" style={{width:"100%"}}/>
             <div class="container">
              <h2>Aysam Farhoud</h2>
              <p class="title">Lead Programmer</p>
              <p>Full Stack Developer & Web Specialist</p>
              <p>aysam@example.com</p>
            </div>
          </div>
        </div>

        <div class="column">
           <div class="card">
            <img src="https://source.unsplash.com/_kFIIY0EYQ4/1600x900" alt="Aysam" style={{width:"100%"}}/>
             <div class="container">
              <h2>Aysam Farhoud</h2>
              <p class="title">Lead Programmer</p>
              <p>Full Stack Developer & Web Specialist</p>
              <p>aysam@example.com</p>
            </div>
          </div>
        </div>
      </div>

      <div class="howitworks-section" id="howitworks">
        <h1>איך זה עובד</h1>
        <p>טקסט שמסביר איך זה עובד - להסכים מה לשים פה</p>
        <p>אפשר עוד טקסט על תועלות ואיך זה עובד</p>
      </div>

      <div class="qa-section" id="qa">
        <h1>שאלות ותשובות</h1>
        <QA />
      </div>
      <br/><br/><br/>

      <h1 id="packages" style={{textAlign: "center", fontWeight: "700"}}>חבילות האתר</h1>
      <PricingTable  highlightColor='#1976D2'>
  
     <PricingSlot highlighted onClick={()=>console.log("here")} buttonText='לרכישה' title='LAWYERZ Premium' priceText='209 ש"ח לחודש'>
        <PricingDetail>לפרסם העברות ולהגיש לידים</PricingDetail>
        <PricingDetail>5 :תחומי התמחות</PricingDetail>
        <PricingDetail>אזורי עבודה: 2</PricingDetail>
        <PricingDetail>גישה חופשית ללוחות האתר (התייעצויות ומודעות)</PricingDetail>
        <PricingDetail>פרסום מודעות ללא הגבלה</PricingDetail>
     </PricingSlot>
     <PricingSlot highlighted onClick={()=>console.log("here")} buttonText='לרכישה' title='LAWYERZ Classic' priceText='179 ש"ח לחודש'>
        <PricingDetail>לפרסם העברות ולהגיש לידים</PricingDetail>
        <PricingDetail>3 :תחומי התמחות</PricingDetail>
        <PricingDetail>2 :אזורי עבודה</PricingDetail>
        <PricingDetail>גישה חופשית ללוחות האתר (התייעצויות ומודעות)</PricingDetail>
        <PricingDetail>פרסום מודעות באופן מוגבל</PricingDetail>
     </PricingSlot>
     <PricingSlot onClick={()=>console.log("here")} buttonText='לרכישה' title='LAWYERZ Essential' priceText='ש"ח לחודש 129'>
        <PricingDetail>רק להגיש בידים על לידים</PricingDetail>
        <PricingDetail>2 :תחומי התמחות</PricingDetail>
        <PricingDetail> אזור עבודה אחד בארץ</PricingDetail>
        <PricingDetail>גישה חופשית ללוחות האתר (התייעצויות ומודעות)</PricingDetail>
        <PricingDetail strikethrough>אפשרות פרסום מודעות</PricingDetail>

     </PricingSlot>
     </PricingTable>
    </div>
  );
}

